import { ArrowUpRight } from "@phosphor-icons/react";
import { useFetch } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export function NewsFeed({ limit = 7 }) {
  const { data, loading, error } = useFetch("/news");
  if (loading) return <div className="space-y-3">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-10" />)}</div>;
  if (error || !data?.length) return <p className="text-sm text-muted-foreground" data-testid="news-empty">News feeds are unavailable right now.</p>;
  return (
    <ul className="space-y-3" data-testid="news-feed">
      {data.slice(0, limit).map((n, i) => (
        <li key={n.link || i}>
          <a href={n.link} target="_blank" rel="noopener noreferrer" className="group block" data-testid={`news-item-${i}`}>
            <p className="text-sm text-slate-800 dark:text-slate-200 group-hover:text-cyan-700 dark:group-hover:text-cyan-400 transition-colors leading-snug">
              {n.title} <ArrowUpRight size={12} className="inline opacity-0 group-hover:opacity-100 transition-opacity" />
            </p>
            <p className="text-[11px] text-muted-foreground mt-0.5">{n.source} · {n.published?.slice(0, 16)}</p>
          </a>
        </li>
      ))}
    </ul>
  );
}
